import { useUserStore } from '@/stores/user';
import { getUserCoupon } from './api';

/**
 * 拉取并同步用户优惠券
 */
export async function refreshUserCoupons(): Promise<void> {
  const { setUserCoupons } = useUserStore.getState();
  const res = await getUserCoupon().catch(() => null);
  setUserCoupons(res?.code === 0 ? (res.data ?? []) : []);
}
